<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane  key="1">
        <span slot="tab">
          <g-wiki keyValue="WIKI_AUXILIOS"/>
          AUXILIOS
        </span>
        <g-master name="auxilios"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  modalWidth="60%"
                  :actions="master.actions"
                  @action="masterAction"
        >
          <template slot="expandedRowRender" slot-scope="{text}">
            <template v-for="ve in master.valoresExpandidos">
              {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
            </template>
          </template>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Empleado')"
                          :formItemConfig="fiOptions"
                          endpoint="empleados_en_reqliquidacion"
                          :selectedObj.sync="empleado"
                          ref="empleado"
                          :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Concepto')"
                          :formItemConfig="fiOptions"
                          endpoint="coc"
                          ref="concepto_base"
                          :decorator="['id_coc', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          :params="filtro_concepto">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Beneficiario')"
                          :formItemConfig="fiOptions"
                          endpoint="personfamily"
                          ref="beneficiario"
                          :disabled="disabledBenef"
                          :params=objEmpleadoSeleccionado
                          :decorator="['id_person_bene', { rules: [{ required: false, message: 'Valor requerido' }] }]">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            style="width: 100%"
                            :label="$t('Nivel de estudio')"
                            :formItemConfig="fiOptions"
                            :decorator="['id_h_level_study', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                            :params="nivel_estudio">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Vigencia desde')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['effective_from', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Vigencia hasta')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['effective_until', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            style="width: 100%"
                            :label="$t('Moneda')"
                            :formItemConfig="fiOptions"
                            :decorator="['currency', { rules: [{ required: true, message: 'Valor requerido'}], initialValue: 'COP' }]"
                            :params="code_currency">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Valor origen')">
                  <a-input-number style="width: 100%" step="1"
                                  v-decorator="['value_source', { rules: [{ required: false}] }]"
                                  :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  ></a-input-number>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Base')">
                  <a-input-number style="width: 100%" step="1"
                                  v-decorator="['base', { rules: [{ required: false}] }]"
                                  :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  ></a-input-number>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Valor auxilio')">
                  <a-input-number style="width: 100%" step="1"
                                  v-decorator="['value_help', { rules: [{ required: false}] }]"
                                  :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  ></a-input-number>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Unidades de entrada')">
                  <a-input-number style="width: 100%" step="1"
                                  v-decorator="['input_units', { rules: [{ required: false}] }]"
                  ></a-input-number>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Unidades de salida')">
                  <a-input-number style="width: 100%" step="1"
                                  v-decorator="['units', { rules: [{ required: false}] }]"
                  ></a-input-number>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Cruce fondo')" :has-feedback="false">
                  <a-checkbox
                    v-decorator="['cruce_creciat', {valuePropName: 'checked' , rules: [{ required: false}], initalValue: false}]">
                  </a-checkbox>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Concepto de cruce')"
                          :formItemConfig="fiOptions"
                          endpoint="coc"
                          :params="{filtro_coc_benefits: true}"
                          ref="concepto_cruce"
                          :decorator="['cross_id_coc', { rules: [{ required: false, message: 'Valor requerido' }] }]">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Comentarios')" v-bind="fiOptions">
                  <a-textarea
                    autoSize
                    v-decorator="['comments', { rules: [{ required: false }] }]">
                  </a-textarea>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Año')" v-bind="fiOptions">
                  <a-select v-decorator="['year', { rules: [
                            { required: true},
                           ] }]" style="width: 100%">
                    <a-select-option v-for="year_ in years" :key="year_">
                      {{ year_ }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Mes')" v-bind="fiOptions">
                  <a-select v-decorator="['month', { rules: [
                            { required: true},
                           ] }]" style="width: 100%">
                    <a-select-option v-for="month_ in months_name" :key="month_.value">
                      {{ month_.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Período')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['period', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :params="period_request">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            :label="$t('Estado')"
                            :formItemConfig="fiOptions"
                            :decorator="['status', { rules: [{ required: false}], initialValue: 'ACT' }]"
                            :params="estado">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Tipo de pago')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['id_h_payroll_type', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                            :params="id_h_param_type"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="cc"
                            style="width: 100%"
                            :label="$t('Centro de Costo')"
                            :formItemConfig="fiOptions"
                            :decorator="['id_cc', { rules: [{ required: false}] }]">
                </g-dropdown>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>

    <template>
      <a-modal v-model="visible" title="Tiempo límite" :footer="null">
        <a-result status="warning"
                  title="La fecha de Novedad ha caducado para el Calendario de Nomina Activo, por favor consulte su administrador HRO">
          <template #extra>
            <a-button @click="handleOk" type="primary">
              Cerrar
            </a-button>
          </template>
        </a-result>
      </a-modal>
    </template>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        visible: false,
        disabledBenef: true,
        estado: {
          h_lookup_type: 'ESTADO_NOVEDAD',
          use_code: true
        },
        id_h_param_type: {
          h_lookup_type: 'TIPO PAGO'
        },
        filtro_concepto: {filtro_concepto_embargos: true},
        empleado: {},
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        code_currency: {
          h_lookup_type: 'MONEDA',
          use_code: true
        },
        nivel_estudio: {
          h_lookup_type: 'NIVEL_ESTUDIO'
        },
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        tipoEntidadSeleccionada: {},
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {},
          'has-feedback': true
        },
        master: {
          actions: [],
          endpoint: 'benefits',
          valoresExpandidos: [
            {label: 'Estado', column: 'estado'},
            {label: 'ID centro de costo', column: 'id_cc'},
            {label: 'Centro de costo', column: 'nombre_cc'},
            {label: 'Año', column: 'year'},
            {label: 'Mes', column: 'mes'},
            {label: 'Periodo', column: 'periodo'},
            {label: 'Tipo de pago', column: 'h_payroll_type'},
            {label: 'Cruce fondo', column: 'cotizante'}
          ],
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre completo', dataIndex: 'nombre_completo', sorter: true},
              {title: 'ID concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Concepto', dataIndex: 'nombre_concepto', sorter: true},
              {title: 'ID beneficiario', dataIndex: 'id_beneficiary', sorter: true},
              {title: 'Nombre del beneficiario', dataIndex: 'nombre_beneficiario', sorter: true},
              {title: 'ID nivel de estudio', dataIndex: 'id_h_level_study', sorter: true},
              {title: 'Nivel de estudio', dataIndex: 'h_level_study', sorter: true},
              {title: 'Vigencia desde', dataIndex: 'fecha_desde', sorter: true},
              {title: 'Vigencia hasta', dataIndex: 'fecha_hasta', sorter: true},
              {title: 'Moneda', dataIndex: 'currency', sorter: true},
              {title: 'Valor origen', dataIndex: 'value_source', sorter: true},
              {title: 'Base', dataIndex: 'base', sorter: true},
              {title: 'Valor de auxilio', dataIndex: 'value_help', sorter: true},
              {title: 'Unidades de entrada', dataIndex: 'input_units', sorter: true},
              {title: 'Unidades de salida', dataIndex: 'units', sorter: true},
              {title: 'ID concepto de cruce', dataIndex: 'cross_id_coc', sorter: true},
              {title: 'Concepto de cruce', dataIndex: 'nombre_costo', sorter: true},
              {title: 'Comentarios', dataIndex: 'comments', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_emp'},
            {name: 'id_coc'},
            {name: 'id_person_bene'},
            {name: 'id_h_level_study'},
            {name: 'effective_from'},
            {name: 'effective_until'},
            {name: 'currency'},
            {name: 'value_source'},
            {name: 'value_help'},
            {name: 'input_units'},
            {name: 'cruce_creciat'},
            {name: 'cross_id_coc'},
            {name: 'comments'},
            {name: 'year'},
            {name: 'month'},
            {name: 'period'},
            {name: 'status'},
            {name: 'id_h_payroll_type'},
            {name: 'id_cc'},
            {name: 'base'},
            {name: 'units'}
          ]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.yearsSelect()
      this.limiteRegistroNovedad()
    },
    methods: {
      yearsSelect () {
        for (let i = this.yearToday - 1; i <= (this.yearToday + 5); i++) {
          this.years.push(i)
        }
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            this.$nextTick(() => {
              if (!JsUtils.isEmpty(action.record.id_emp)) {
                this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_emp)
              }
              if (!JsUtils.isEmpty(action.record.cross_id_coc)) {
                this.$refs.concepto_cruce && this.$refs.concepto_cruce.handleSearch(action.record.cross_id_coc)
              }
              if (!JsUtils.isEmpty(action.record.id_coc)) {
                this.$refs.concepto_base && this.$refs.concepto_base.handleSearch(action.record.id_coc)
              }
              if (!JsUtils.isEmpty(action.record.id_person_bene)) {
                this.$refs.beneficiario && this.$refs.beneficiario.handleSearch(action.record.id_person_bene)
              }
            })
            break

          case 'fieldsChange':
            if (!JsUtils.isEmpty(action.changedFields)) {
              if (!JsUtils.isEmpty(action.changedFields.id_emp)) {
                this.disabledBenef = false
              } else {
                this.disabledBenef = true
              }
            }
            break
          case 'masterCreate':
            this.disabledBenef = true
            break
        }
      },
      handleOk () {
        this.visible = false
      },

      limiteRegistroNovedad () {
        if (this.$userIsInrol('RightHand') || this.$userIsInrol('Management') || this.$userIsInrol('AdminNomina')) {
          this.master.actions.push({
            name: 'masterCreate',
            text: 'Crear',
            permisos: [],
            props: {icon: 'plus', type: 'button'}
          })
        } else {
          this.httpClient.getInstance().get('tiempo_limite')
            .then(response => {
              if (response.data[0].tiempolimite !== '1') {
                this.visible = true
                this.master.actions.splice(0)
              } else {
                this.master.actions.push({
                  name: 'masterCreate',
                  text: 'Crear',
                  permisos: [],
                  props: {icon: 'plus', type: 'button'}
                })
              }
            })
            .catch(() => {
              Mensajes.error('Error', 'No fue posble cargar el tiempo límite para registrar una novedad')
            })
        }
      }
    },
    computed: {
      objEmpleadoSeleccionado () {
        let emp = ''
        if (!JsUtils.isEmpty(this.empleado)) {
          emp = this.empleado.id_emp
          return {filtro_benefits: true, id_empleado: emp}
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/Benefits.vue